import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import { keyframes } from '@emotion/core';
import { N40A, N500 } from '@atlaskit/theme/colors';
import { createTheme } from '@atlaskit/theme/components';
var increasingBarAnimation = keyframes(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  from { left: -5%; width: 5%; }\n  to { left: 130%; width: 100%;}\n"])));
var decreasingBarAnimation = keyframes(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  from { left: -80%; width: 80%; }\n  to { left: 110%; width: 10%;}\n"])));
export var Theme = createTheme(function (props) {
  return {
    container: {
      background: N40A,
      borderRadius: 3,
      height: 6,
      overflow: 'hidden',
      position: 'relative',
      width: "100%"
    },
    bar: {
      borderRadius: 3,
      display: 'block',
      height: 6,
      position: 'absolute',
      background: N500
    },
    determinateBar: {
      transition: 'width 0.2s',
      width: "".concat(Number(props.value) * 100, "%")
    },
    increasingBar: {
      animation: "".concat(increasingBarAnimation, " 2s infinite")
    },
    decreasingBar: {
      animation: "".concat(decreasingBarAnimation, " 2s 0.5s infinite")
    }
  };
});